const Filters = {

	allValue: 'all',
	loading: false,
	timeout: null,
	prevQueryUrl: '',
	init: () => {
		Filters.initCategoryChange();
		Filters.initSelectChange();
	},

	initSelectChange: () => {
		const selects = document.querySelectorAll(`[data-archive-select]`);
		selects.forEach((select) => {
		    select.addEventListener('change', (ev) => {
				Filters.debounce(Filters.applyFilters);
			});
		})
	},

	initCategoryChange: () => {
		const checkboxes = document.querySelectorAll(`[data-archive-category]`);
		checkboxes.forEach((element) => {
		    element.addEventListener('change', (ev) => {
				ev.preventDefault();
				Filters.deselectCategories(ev.target, '[data-archive-category-all]');
				Filters.debounce(Filters.applyFilters);
			});
		});
		const allCheckboxes = document.querySelectorAll(`[data-archive-category-all]`);
		allCheckboxes.forEach((element) => {
			element.addEventListener('change', (ev) => {
				ev.preventDefault();
				Filters.deselectCategories(ev.target, '[data-archive-category]');
				Filters.debounce(Filters.applyFilters);
			});
		});
	},

	debounce: (callback) => {
		if(Filters.timeout){
			clearTimeout(Filters.timeout);
			Filters.timeout = null;
		}
		Filters.timeout = setTimeout(callback, 1000);
	},

	setLoading: (state) => {
		Filters.loading = state;
		document.body.classList.toggle('is-loading', state);
	},
	pushHistory: (url) => {
		Filters.prevQueryUrl = url;
		window.history.replaceState({}, "", url);
	},

	applyFilters: async () => {
		if(Filters.loading) return;

		const form = document.querySelector(`[data-archive-filters]`);
		if(!form){
		    return;
		}

		const ajaxFormData = new FormData();
		ajaxFormData.append('ajax', '1');
		const formData = new FormData(form);

		if(formData.get('terms[]') === 'all'){
			formData.delete('terms[]')
		}

		let queryUrl = new URLSearchParams(formData).toString();
		queryUrl = '?'+queryUrl;

		Filters.setLoading(true);

		try {
			let result = await fetch(queryUrl, {
				method: 'post',
				body: ajaxFormData
			});
			result = await result.text();
			Filters.pushHistory(queryUrl);

			const content = document.querySelector(`[data-archive-content]`);
			if(!content){
			    return;
			}
			content.outerHTML = result;

		}catch (e){
			console.warn(e);
		}
		Filters.setLoading(false);

	},

	deselectCategories: (input, selector) => {
		const wrapper = input.closest('[data-archive-categories]');
		const checkboxes = wrapper.querySelectorAll(selector);

		checkboxes.forEach((element) => {
			element.checked = false;
		});
		Filters.checkAllCategoryIfNecessary(input);
	},
	checkAllCategoryIfNecessary: (input) => {
		const wrapper = input.closest('[data-archive-categories]');
		const checkboxes = wrapper.querySelectorAll('[data-archive-category]');
		let anyChecked = false;
		checkboxes.forEach((element) => {
			if(element.checked){
				anyChecked = true;
			}
		})
		if(!anyChecked){
			const allCheckboxes = wrapper.querySelectorAll('[data-archive-category-all]');
			allCheckboxes.forEach((element) => {
				element.checked = true;
			})
		}

	}


}
export default Filters;
